import React from 'react';
import { styled } from "../stitches.config"

import YouTube from "./assets/icons/medialinks/youtube.svg"
import Apple from "./assets/icons/medialinks/apple.svg"
import Spotify from "./assets/icons/medialinks/spotify.svg"

type ExtendedProps = {
    spotify?: string;
    apple?: string;
    youtube?: string;
};

type MediaLinksProps = {
    element: ExtendedProps
}

const MediaLinks: React.FC<MediaLinksProps> = ({
    element
}) => {
    const {
        spotify,
        youtube,
        apple,
    } = element;
    return (
        <StyledMediaLinks>
            {spotify && <a className="spotify" href={spotify} target="_blank"></a>}
            {apple && <a className="apple" href={apple} target="_blank"></a>}
            {youtube && <a className="yt" href={youtube} target="_blank"></a>}
        </StyledMediaLinks>
    );
};

const StyledMediaLinks = styled('div', {
    display: "flex",
    margin: "24px 0 32px 0",
    width: "100%",
    justifyContent: "space-between",
    "@bp3": {
        margin: "32px 0 40px 0",
        justifyContent: "flex-start",
        width: "auto",
    },
    "& a": {
        width: "100px",
        height: "40px",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        "@bp3": {
            marginRight: "16px",
        }
    },
    "& .yt": {
        backgroundImage: `url("${YouTube}")`,
    },
    "& .spotify": {
        width: "106px",
        backgroundImage: `url("${Spotify}")`,
    },
    "& .apple": {
        backgroundImage: `url("${Apple}")`,
    },
})


export default MediaLinks